import { getOnboardingStatus, getRegion } from './config'
import { readCacheWithTtl, writeCacheWithTtl, clearCache } from '../modules/utils/cacheWithTtl'

const KEY_ONBOARDING_STATUS = 'ca:onboarding-status'
const TTL_ONBOARDING_STATUS_MS = 30 * 60 * 1000
let inFlightOnboarding = null

export async function getOnboardingStatusCached() {
  const cached = readCacheWithTtl(KEY_ONBOARDING_STATUS, sessionStorage)
  if (cached) {
    console.info('[OnboardingStatus] origen=cache')
    return { resp: cached, source: 'cache' }
  }

  if (inFlightOnboarding) return inFlightOnboarding

  inFlightOnboarding = (async () => {
    try {
      const resp = await getOnboardingStatus()
      writeCacheWithTtl(KEY_ONBOARDING_STATUS, resp, TTL_ONBOARDING_STATUS_MS, sessionStorage)
      console.info('[OnboardingStatus] origen=servicio')
      return { resp, source: 'service' }
    } finally {
      inFlightOnboarding = null
    }
  })()

  return inFlightOnboarding
}

export function clearOnboardingStatusCache() {
  clearCache(KEY_ONBOARDING_STATUS, sessionStorage)
}

const KEY_REGIONES = 'ca:regiones'
const TTL_REGIONES_MS = 24 * 60 * 60 * 1000
let inFlightRegiones = null

export async function getRegionCached() {
  const cached = readCacheWithTtl(KEY_REGIONES, sessionStorage)
  if (cached) {
    console.info('[Regiones] origen=cache')
    return cached
  }

  if (inFlightRegiones) return inFlightRegiones

  inFlightRegiones = (async () => {
    try {
      const resp = await getRegion()
      writeCacheWithTtl(KEY_REGIONES, resp, TTL_REGIONES_MS, sessionStorage)
      console.info('[Regiones] origen=servicio')
      return resp
    } finally {
      inFlightRegiones = null
    }
  })()

  return inFlightRegiones
}

export function clearRegionCache() {
  clearCache(KEY_REGIONES, sessionStorage)
}
